import React from "react";
import { api } from "../../lib/api";
import { act } from "../../lib/useFetch";
import { ROLE_LABELS, USER_STATUSES } from "../../lib/constants";

const btn = "btn-outline !py-1.5 !px-3 text-xs";

export default function UserRow({ u, isOwner, onOpen, onChanged }) {
  const setStatus = async (e) => {
    await act(api.patch(`/admin/users/${u.id}/status`, { status: e.target.value }), "Статус обновлён");
    onChanged();
  };
  const toggleBlock = async () => {
    if (!window.confirm(u.blocked ? "Разблокировать пользователя?" : "Заблокировать пользователя?")) return;
    await act(api.patch(`/admin/users/${u.id}/block`, { blocked: !u.blocked }), u.blocked ? "Разблокирован" : "Заблокирован");
    onChanged();
  };

  return (
    <div className="glass-cyan rounded-xl p-4" data-testid={`user-row-${u.id}`}>
      <div className="flex flex-wrap items-center gap-3">
        <span className="font-medium">{u.name}</span>
        <span className="text-xs text-gray-400">{u.email}</span>
        <span className="chip">{ROLE_LABELS[u.role]}</span>
        <span className="text-xs" data-testid={`user-status-${u.id}`}>{USER_STATUSES[u.status]}</span>
        <span className="chip">{u.language}</span>
        {u.blocked && <span className="text-xs text-red-400" data-testid={`user-blocked-${u.id}`}>🔒 Доступ заблокирован</span>}
        <span className="text-xs text-gray-500 ml-auto">Заказов: {u.orders_count} · Отзывов: {u.reviews_count}</span>
      </div>
      <div className="flex flex-wrap gap-2 mt-3">
        <button className={btn} onClick={() => onOpen("stats")} data-testid={`user-stats-${u.id}`}>📊 Статистика</button>
        {isOwner && (
          <>
            <button className={btn} onClick={() => onOpen("order")} data-testid={`user-add-order-${u.id}`}>➕ Заказ</button>
            <button className={btn} onClick={() => onOpen("profile")} data-testid={`user-edit-${u.id}`}>✏️ Профиль</button>
            <button className={btn} onClick={() => onOpen("review")} data-testid={`user-add-review-${u.id}`}>➕ Отзыв</button>
            <select value={u.status} onChange={setStatus} className="!w-auto !py-1.5 !px-3 text-xs" title="🏷️ Статус" data-testid={`user-status-select-${u.id}`}>
              {Object.entries(USER_STATUSES).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
            </select>
            {u.role !== "owner" && (
              <button className={btn} onClick={toggleBlock} data-testid={`user-block-${u.id}`}>{u.blocked ? "🔓 Разблокировать" : "🔒 Заблокировать"}</button>
            )}
            <a className={btn} href={`mailto:${u.email}?subject=${encodeURIComponent("ARVEX")}`} data-testid={`user-email-${u.id}`}>✉️ Написать письмо</a>
          </>
        )}
      </div>
    </div>
  );
}
